import { z } from 'zod';
import {
  CreateTestDataRequestSchema,
  PatchTestDataRequestSchema,
  QualityTestDataSchema,
  TEST_DATA_SCOPE_LEVELS,
  TestDataListResponseSchema,
  TestDataResponseSchema,
} from './test-data';

export { TEST_DATA_SCOPE_LEVELS };
export type { TestDataScopeLevel } from './test-data';

export const TestDataTemplateSchema = QualityTestDataSchema.extend({
  scopeLevel: z.enum(['org', 'global']),
  orgId: z.string().uuid().nullable().optional(),
  projectId: z.null().optional(),
});
export type TestDataTemplate = z.infer<typeof TestDataTemplateSchema>;

export const TestDataTemplateListResponseSchema = z.object({
  orgId: z.string().uuid().nullable().optional(),
  scopeLevel: z.enum(['org', 'global']),
  items: z.array(TestDataTemplateSchema),
});
export type TestDataTemplateListResponse = z.infer<typeof TestDataTemplateListResponseSchema>;

export const CreateTestDataTemplateRequestSchema = CreateTestDataRequestSchema;
export type CreateTestDataTemplateRequest = z.infer<typeof CreateTestDataTemplateRequestSchema>;

export const PatchTestDataTemplateRequestSchema = PatchTestDataRequestSchema;
export type PatchTestDataTemplateRequest = z.infer<typeof PatchTestDataTemplateRequestSchema>;

export const TestDataTemplateResponseSchema = TestDataResponseSchema.extend({
  item: TestDataTemplateSchema,
});
export type TestDataTemplateResponse = z.infer<typeof TestDataTemplateResponseSchema>;

export const TestDataTemplateAdoptionSchema = z.object({
  id: z.string().uuid(),
  projectId: z.string().uuid(),
  orgId: z.string().uuid(),
  templateId: z.string().uuid(),
  templateKey: z.string(),
  templateScopeLevel: z.enum(['org', 'global']),
  templateName: z.string(),
  enabled: z.boolean(),
  rowIndex: z.number().int().nonnegative().nullable(),
  selectedRowIndexes: z.array(z.number().int().nonnegative()).default([]),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type TestDataTemplateAdoption = z.infer<typeof TestDataTemplateAdoptionSchema>;

export const TestDataTemplateAdoptionListResponseSchema = z.object({
  projectId: z.string().uuid(),
  items: z.array(TestDataTemplateAdoptionSchema),
});
export type TestDataTemplateAdoptionListResponse = z.infer<typeof TestDataTemplateAdoptionListResponseSchema>;

export const CreateTestDataTemplateAdoptionRequestSchema = z.object({
  templateId: z.string().uuid(),
  enabled: z.boolean().optional(),
  rowIndex: z.number().int().nonnegative().nullable().optional(),
  selectedRowIndexes: z.array(z.number().int().nonnegative()).max(100).optional(),
});
export type CreateTestDataTemplateAdoptionRequest = z.infer<typeof CreateTestDataTemplateAdoptionRequestSchema>;

export const PatchTestDataTemplateAdoptionRequestSchema = z.object({
  enabled: z.boolean().optional(),
  rowIndex: z.number().int().nonnegative().nullable().optional(),
  selectedRowIndexes: z.array(z.number().int().nonnegative()).max(100).optional(),
});
export type PatchTestDataTemplateAdoptionRequest = z.infer<typeof PatchTestDataTemplateAdoptionRequestSchema>;

/** Effective catalogue row shown in project library — project-owned or inherited template. */
export const TestDataEffectiveCatalogueEntrySchema = QualityTestDataSchema.extend({
  scopeOrigin: z.enum(['project', 'org', 'global']),
  templateId: z.string().uuid().nullable().optional(),
  adoptionId: z.string().uuid().nullable().optional(),
  adopted: z.boolean().optional(),
});
export type TestDataEffectiveCatalogueEntry = z.infer<typeof TestDataEffectiveCatalogueEntrySchema>;

export const TestDataEffectiveListResponseSchema = TestDataListResponseSchema.extend({
  items: z.array(TestDataEffectiveCatalogueEntrySchema),
});
export type TestDataEffectiveListResponse = z.infer<typeof TestDataEffectiveListResponseSchema>;
